import ScrollMagic from 'scrollmagic';
import { TweenMax } from 'gsap';
import 'scrollmagic-gsap';

class ExplodedBattery {
  constructor(scrollers, explodedBattery) {
    this.scrollers = scrollers;
    this.explodedBattery = explodedBattery;

    this.bindScrollMagic();
  }

  isMobile = () => window.matchMedia('(max-width: 992px)').matches;

  bindScrollMagic = () => {
    const controller = new ScrollMagic.Controller();

    Array.forEach(this.scrollers, (scroller, index) => {
      const scrollItemScene = new ScrollMagic.Scene({
        triggerElement: scroller,
        triggerHook: this.isMobile() ? 0.65 : 0.5,
        duration: this.isMobile() ? 0 : 500,
        reverse: true,
      });

      if (!this.isMobile()) {
        scrollItemScene.setPin(scroller);

        // Battery Section Animation
        const sectionId = scroller.getAttribute('data-section-id');
        const section = this.explodedBattery.querySelector(`[data-section-id="${sectionId}"]`);

        if (section !== null) {
          this.handleSectionAnimation(scrollItemScene, section, index);
        }
        // End Battery Section Animation

        scrollItemScene.on('end', (e) => {
          if (e.scrollDirection === 'FORWARD' && (index + 1) === this.scrollers.length) {
            this.explodedBattery.classList.add('phase-5');
          }
          if (e.scrollDirection === 'REVERSE' && (index + 1) === this.scrollers.length) {
            this.explodedBattery.classList.remove('phase-5');
          }
        });
      }
      scrollItemScene.setClassToggle(scroller, 'active');

      scrollItemScene.addTo(controller);
    });
  }

  handleSectionAnimation(scrollItemScene, section, index) {
    index += 1;

    const tween = TweenMax.fromTo(section, 0.3, this.getFromTween(index), this.getToTween(index));
    scrollItemScene.setTween(tween);
  }

  getFromTween(index) {
    switch (index) {
      case 1:
        return {
          opacity: 0,
          yPercent: 50,
          ease: Linear.easeNone,
        };
      case 2:
        return {
          opacity: 0,
          yPercent: 40,
          ease: Linear.easeNone,
        };
      case 3:
        return {
          opacity: 0,
          yPercent: 135,
          ease: Linear.easeNone,
        };
      case 4:
        return {
          opacity: 0,
          yPercent: 149,
          ease: Linear.easeNone,
        };

      default:
        return {};
    }
  }

  getToTween(index) {
    switch (index) {
      case 1:
        return {
          opacity: 1,
          yPercent: -50,
          ease: Linear.easeNone,
        };
      case 2:
        return {
          opacity: 1,
          yPercent: -40,
          ease: Linear.easeNone,
        };
      case 3:
        return {
          opacity: 1,
          yPercent: 35,
          ease: Linear.easeNone,
        };
      case 4:
        return {
          opacity: 1,
          yPercent: 49,
          ease: Linear.easeNone,
        };

      default:
        return {};
    }
  }
}


$(document).ready(() => {
  const scrollers = document.querySelectorAll('.js-exploded-scroll-item');
  const explodedBattery = document.querySelector('.js-exploded-battery');

  if (scrollers !== null && scrollers.length > 0 && explodedBattery !== null) {
    // eslint-disable-next-line
    new ExplodedBattery(scrollers, explodedBattery);
  }
});
